import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Sidebar.css';

const menuItems = [
  'داشبورد کلان (پورتفوی کلی)',
  'ثبت معامله',
  'پورتفوی',
  'تحلیل بازار آتی (Futures)',
  'مدیریت داده‌ها (ویرایش/حذف)',
  'زنجیره آپشن (تحلیل زنده)',
  'استراتژی‌های آپشن',
  'فرصت‌های بازار',
  'استراتژی چرخه (Wheel Strategy)',
  'تنظیمات کمیسیون',
  'حساب کاربری'
];

function Sidebar({ onMenuSelect, currentMenu, user: propUser }) {
  const { user: authUser, logout } = useAuth();
  const navigate = useNavigate();

  const user = propUser || authUser;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="sidebar">
      <div className="sidebar-title">
        <h2>📈 پنل مدیریت سرمایه</h2>
      </div>

      {user && (
        <div className="sidebar-user">
          <div className="user-avatar">
            {user.full_name ? user.full_name.charAt(0) : user.email.charAt(0).toUpperCase()}
          </div>
          <div className="user-info">
            <span className="user-name">{user.full_name || user.email}</span>
            <span className="user-email">{user.email}</span>
          </div>
        </div>
      )}

      <div className="sidebar-menu">
        {(user?.is_investor && !(user?.is_admin || user?.is_fund_manager) ? ['سرمایه‌گذاری من', 'حساب کاربری'] : (user?.is_admin || user?.is_fund_manager) ? [...menuItems.slice(0, -1), 'سبدگردانی', 'حساب کاربری'] : menuItems).map((item) => (
          <button
            key={item}
            className={`sidebar-button ${currentMenu === item ? 'active' : ''}`}
            onClick={() => onMenuSelect(item)}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="sidebar-footer">
        <button className="sidebar-logout" onClick={handleLogout}>
          🚪 خروج
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
